document.addEventListener('DOMContentLoaded', function () {
  const faqGroupLinks = document.querySelectorAll('.faq-group-title-link');
  const faqGroups = document.querySelectorAll('.faq-group');

  document.querySelectorAll('.sc-frequently-about .accordion-body p').forEach((answer) => {
    const textNodes = document.createTreeWalker(answer, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (textNodes.nextNode()) nodes.push(textNodes.currentNode);

    nodes.forEach((node) => {
      if (node.parentElement.closest('a')) return;

      const text = node.textContent;
      const linkPattern = /\[([^\]\n]+)\]\(((?:https?:\/\/|\/(?!\/))[^\s)]+)\)/g;
      const matches = [...text.matchAll(linkPattern)];
      if (!matches.length) return;

      const fragment = document.createDocumentFragment();
      let position = 0;
      matches.forEach((match) => {
        fragment.append(document.createTextNode(text.slice(position, match.index)));
        const link = document.createElement('a');
        link.href = match[2];
        link.textContent = match[1];
        fragment.append(link);
        position = match.index + match[0].length;
      });
      fragment.append(document.createTextNode(text.slice(position)));
      node.replaceWith(fragment);
    });
  });

  const observerOptions = {
    root: null,
    rootMargin: '-50px 0px -50% 0px',
    threshold: 0.5,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        faqGroupLinks.forEach((link) => link.classList.remove('active'));
        document.querySelector(`.faq-group-title-link[href="#${entry.target.id}"]`)?.classList.add('active');
      }
    });
  }, observerOptions);

  faqGroups.forEach((group) => observer.observe(group));

  faqGroupLinks.forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop - 150,
          behavior: 'smooth',
        });
      }
    });
  });

  $('.faq-group-titles-select').on('change', function () {
    const target = $(this).val();
    if (target.startsWith('#')) {
      $('html, body').animate({ scrollTop: $(target).offset().top - 150 }, 500);
    } else {
      window.location.href = target;
    }
  });
});
